import React from 'react';

export default class PageTemplate extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div style={{ position: "absolute", bottom: "20px", left: "20px" }}>
          <h3>Settlement Report</h3>
        </div>
        <div style={{ position: "absolute", top: "20px", right: "20px" }}>
          <img src={'assets/DCSX.png'}  height={80} alt={'DCSX'}/>
        </div>
        <div style={{ position: "absolute", bottom: "20px", right: "20px" }}>
          Page {this.props.pageNum} of {this.props.totalPages}
        </div>
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/main/ReportTemplates/SettlementReport.js